import {
  MappedPanelError,
  mapPanelError,
  PanelErrorRoute,
} from "../panelErrors";
import { HoldingTradeFormValues } from "./types";

export type HoldingTradeErrorField = keyof HoldingTradeFormValues;

export type MappedHoldingTradeActionError =
  MappedPanelError<HoldingTradeErrorField>;

// Sibling of `holdingTradeErrors.ts`'s table, not a reuse: these payloads have `holdingId` but no `instrumentId`,
// so an unpriced-instrument or unreconciled-action rejection routes to the position selector ("holding") instead.
const ROUTES: readonly PanelErrorRoute<HoldingTradeErrorField>[] = [
  // Service-level guards.
  ["Cannot execute trade on", "holding"],
  ["Cannot value holdings", null],
  ["Trade would create a negative historical quantity", "quantity"],
  ["Trade date", "date"],
  ["Trade quantity", "quantity"],
  ["Trade amount", "amountEur"],
  // DTO constraint messages and the 404, matched on their field prefix.
  ["Holding", "holding"],
  ["Quantity ", "quantity"],
  ["Amount ", "amountEur"],
  ["Fee ", "feeEur"],
  ["Tax ", "taxWithheld"],
  ["Effective date ", "date"],
  ["Instrument ", "holding"],
];

export const mapHoldingTradeActionError = (
  messages: string[],
): MappedHoldingTradeActionError => mapPanelError(messages, ROUTES);
